import React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import { EnvironmentContext } from 'config/environment'
import { BankingValueObjectsOnboardingCreationSourceValueEnum } from 'generated/resources/graphql'

import { track } from 'modules/core/lib/Tracking'

import { getAccountUrl } from 'modules/banking/components/AccountOnboarding/utils'

interface AccountOnboardingButtonProps {
  label: string
  source: BankingValueObjectsOnboardingCreationSourceValueEnum
  trackingEvent?: string
  trackingSectionName?: string
  type?: 'primary' | 'secondary'
  legalEntityId?: string
}

const AccountOnboardingButton = ({
  label,
  source,
  trackingEvent,
  trackingSectionName,
  type = 'primary',
  legalEntityId,
}: AccountOnboardingButtonProps) => {
  const environment = React.useContext(EnvironmentContext)
  const handleOnClick = () => {
    if (trackingEvent) {
      track(trackingEvent, { section: trackingSectionName })
    }
    window.location.href = getAccountUrl(environment, source, legalEntityId)
  }

  return (
    <Button type={type} onClick={handleOnClick} iconName="external link">
      {label}
    </Button>
  )
}

export default AccountOnboardingButton
